export const GLOBAL_VERSION = '20230710';
//# sourceMappingURL=constants.js.map